import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsLvtCamera extends SnModel {
  @Expose({ name: 'id' })
  private idV1: string;

  @Expose({ name: 'cameraId' })
  private idV2: string;

  @Expose()
  public manufacturer: string;

  @Expose()
  public model: string;

  @Expose()
  public serialNumber: any;

  @Expose({ name: 'name' })
  private nameV1: string;

  @Expose({ name: 'cameraName' })
  private nameV2: string;

  @Expose()
  public mountPosition: string;

  @Expose()
  public role: string;

  @Expose()
  public thermal: boolean;

  @Expose()
  public viewType: string;

  @Expose()
  public liveUnitId: string;

  @Expose()
  public liveUnitName: string;

  @Expose()
  public coordinates: number[];

  @Expose()
  public gpsLocation: { latitude: number; longitude: number };

  @Expose()
  public clientId: string;

  @Expose()
  public locationId: string;

  @Expose()
  public capabilities: { position: boolean };

  @Expose()
  public accountName: string;

  get coords(): { lng: number; lat: number } {
    return {
      lng: this.gpsLocation?.longitude || this.coordinates[0],
      lat: this.gpsLocation?.latitude || this.coordinates[1],
    };
  }

  // Alias for v1 property "id"
  get id(): string {
    return this.idV1 || this.idV2;
  }

  // Alias for v1 property "name"
  get name(): string {
    return this.nameV1 || this.nameV2;
  }

  // Alias for v1 property "id"
  get cameraId(): string {
    return this.idV1 || this.idV2;
  }

  // Alias for v1 property "name"
  get cameraName(): string {
    return this.nameV1 || this.nameV2;
  }

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
    this.coordinates = [
      data.gpsLocation?.longitude || data.lng,
      data.gpsLocation?.latitude || data.lat,
    ];
    if (!this.gpsLocation && data.lng && data.lat) {
      this.gpsLocation = { longitude: data.lng, latitude: data.lat };
    }
  }
}
